import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface RequestAssessmentVM {
  request?: boolean;
  note?: string;
  tipoUltimaOperazione?: string;
}

interface AccordionRequestMessiVerificationFormProps {
  disabled?: boolean;
  values?: RequestAssessmentVM;
  errors?: FormikErrors<RequestAssessmentVM>;
  touched?: FormikTouched<RequestAssessmentVM>;
  hasAttentionNote?: boolean;
  onChange: (
    key: keyof RequestAssessmentVM,
    value: RequestAssessmentVM[keyof RequestAssessmentVM]
  ) => void;
  onChanges: (values: RequestAssessmentVM) => void;
  disabledMessi?: boolean;
}

const AccordionRequestMessiVerificationFormComponent = ({
  values,
  onChange,
  onChanges,
  touched,
  errors,
  hasAttentionNote,
  disabled,
  disabledMessi,
}: AccordionRequestMessiVerificationFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="request"
              checked={values?.request || false}
              onChange={() =>
                onChanges({
                  request: !values?.request,
                  note: '',
                })
              }
              inputProps={{ 'aria-label': 'Richiesta accertamento messi' }}
              disabled={disabled || disabledMessi}
            />
          }
          label="Richiesta accertamento messi"
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="note"
          label="Nota per ufficio messi"
          aria-label="Nota per ufficio messi"
          fullWidth
          multiline
          rows={7}
          inputProps={{
            maxLength: '240',
          }}
          onChange={(event) => {
            onChange('note', event.target.value);
          }}
          value={values?.note || ''}
          error={touched?.note && Boolean(errors?.note)}
          helperText={errors?.note}
          disabled={disabled}
        />
      </Grid>
      {hasAttentionNote ? (
        <Grid item xs={12}>
          <Typography color="cdmBrand.main" fontWeight={'bold'} sx={{ textTransform: 'uppercase' }}>
            Attenzione esiste accertamento ancora in carico al servizio messi
          </Typography>
        </Grid>
      ) : undefined}
    </Grid>
  );
};

AccordionRequestMessiVerificationFormComponent.displayName =
  'Accordion return comunication form component';

const AccordionRequestMessiVerificationForm = memo(AccordionRequestMessiVerificationFormComponent);

export default AccordionRequestMessiVerificationForm;
